import { AutoComplete } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../services/mainApi.service";

const translationPath = "chatBot.page.service.ticketServiceArea.";

const TICKET_AUTOMATION_RECEIVED_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationReceivedRule/";
const ticketAutomationReceivedRuleService = new MainApi(
  TICKET_AUTOMATION_RECEIVED_RULE_ROUTE
);

const TicketDefaultDocField = () => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <AutoComplete
        getOptionLabel={(option) => {
          return option.name;
        }}
        size="small"
        label={t(translationPath + "ticket_automation_received_rule")}
        name="ticketAutomationReceivedRule"
        request={ticketAutomationReceivedRuleService.list}
      />
    </Grid>
  );
};

export default memo(TicketDefaultDocField);
